<script setup lang="ts">
import { ref } from "vue";
import DiamondsDiamondDetails from "@/components/diamonds/diamondsDiamondDetails.vue";
import DiamondsSearch from "@/components/diamonds/diamondsSearch.vue";
import StepWidget from "@/components/stepWidget.vue";

const certificatedDiamondData = ref(null);

const getDiamondId = () => {
  let path = window.location.pathname
  if (/\/diamonds\/search\//.test(path)) {
    return ""
  }
  if (/\/diamonds\/(.*)/.test(path)) {
    if (path.endsWith("/")) {
      path = path.substring(0, path.length - 1)
    }

    const parts = path.split('/')
    const lastPart = parts.pop() as string
    if (lastPart === 'diamonds' || lastPart === 'search') {
      return ""
    }
    return lastPart
  }
  return ""
}
</script>

<template>
  <div>
    <step-widget :show=true @certificatedDiamond="(data) => certificatedDiamondData = data"/>
    <div v-if="getDiamondId() !== ''">
      <diamonds-diamond-details :diamond-id="getDiamondId()"/>
    </div>
    <div v-else>
      <diamonds-search :certificated-diamond="certificatedDiamondData"/>
    </div>
  </div>
</template>

<style scoped>

</style>